import { buildProps, definePropType, guid } from '@ll-plus/utils'
import type { ExtractPropTypes } from 'vue'
import { type FormColumn } from '@ll-plus/components'
import type KeyValue from '../key-value.vue'

// 定义 IKeyType 接口
export interface IKeyType {
  label: string
  value: string
  option: FormColumn
}

// 定义 IKeyValueReturn 接口
export interface IKeyValueReturn {
  key: any | null
  value: any | null
}

// 定义 IKeyValueItem 类型
export type IKeyValueItem = IKeyValueReturn & { guid: string }

// 定义 IKeyValueType 类型
type IKeyValueType = 'single' | 'doubt'

// 定义 getKeyValueItem 函数
export const getKeyValueItem = (): IKeyValueItem => ({
  key: null,
  value: null,
  guid: guid(),
})

// 定义 keyValueProps 常量
export const keyValueProps = buildProps({
  value: {
    type: definePropType<IKeyValueReturn[]>(Array),
    default: (): IKeyValueReturn[] => [{ key: null, value: null }],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  keyLabel: {
    type: String,
    default: '',
  },
  valueLabel: {
    type: String,
    default: '',
  },
  addText: {
    type: String,
    default: '添加',
  },
  keyValueType: {
    type: definePropType<IKeyValueType>(String),
    default: 'doubt',
  },
  keyType: {
    type: definePropType<FormColumn>(Object),
    default: (): FormColumn => ({
      type: 'input',
      placeholder: '请输入Key',
    }),
  },
  keyTypes: {
    type: definePropType<IKeyType[]>(Array),
    default: (): IKeyType[] => [],
  },
  valueType: {
    type: definePropType<FormColumn>(Object),
    default: (): FormColumn => ({
      type: 'input',
      placeholder: '请输入Value',
    }),
  },
  disabledValue: {
    type: definePropType<number[]>(Array),
    default: (): number[] => [],
  },
  disabledKey: {
    type: definePropType<number[]>(Array),
    default: (): number[] => [],
  },
  disabledDelete: {
    type: definePropType<number[]>(Array),
    default: (): number[] => [],
  },
  disabledAdd: {
    type: Boolean,
    default: false,
  },
  validate: {
    type: Boolean,
    default: false,
  },
  keepLast: {
    type: Boolean,
    default: true,
  },
} as const)

// 定义 IKeyValueAddEmits 接口
export interface IKeyValueAddEmits {
  index: number
  item: IKeyValueItem
  value: IKeyValueItem[]
}

// 定义 keyValueEmits 常量
export const keyValueEmits = {
  change: (value: IKeyValueReturn[]): boolean => !!value,
  add: (params: IKeyValueAddEmits): boolean => !!params,
  delete: (index: number): boolean => typeof index === 'number',
  'update:value': (value: IKeyValueReturn[]): boolean => !!value,
}

// 定义 KeyValueProps 类型
export type KeyValueProps = ExtractPropTypes<typeof keyValueProps>
// 定义 KeyValueEmits 类型
export type KeyValueEmits = typeof keyValueEmits
// 定义 KeyValueInstance 类型
export type KeyValueInstance = InstanceType<typeof KeyValue>
